import {Button} from "@matillion/component-library"

export default function DownloadButton({object, name, title, ...buttonProps}) {
    let link = window.URL.createObjectURL(new Blob([JSON.stringify(object)], { type: "text/json" }))
    return (
        <a style={{textDecoration: "none"}} href={link} download={`${name}.json`}>
            <Button {...buttonProps}  >{title}</Button>
        </a>
    )
}